<script setup>
import { watch, onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useCartStore } from '@/stores/cart'
import { useChatStore } from '@/stores/chat'
import { hasFeature } from '@/brand'
import CookieConsentComponent from '@/components/CookieConsentComponent.vue'
import ChatWidget from '@/components/chat/ChatWidget.vue'

const route = useRoute()
const authStore = useAuthStore()
const cartStore = useCartStore()
const chatStore = useChatStore()

// Watch for auth state changes and refresh cart accordingly
watch(() => authStore.isAuthenticated, async (isAuthenticated, wasAuthenticated) => {
  // Only refresh if auth state actually changed (not initial load)
  if (wasAuthenticated !== undefined && isAuthenticated !== wasAuthenticated) {
    console.log('Auth state changed, refreshing cart...')
    try {
      await cartStore.getCart()
    } catch (error) {
      console.warn('Failed to refresh cart on auth change:', error)
    }
  }
}, { immediate: false })

// Support chat: chats started as a guest move to the account on login / registration,
// on logout the current chat stays with the previous account
watch(() => authStore.isAuthenticated, (isAuthenticated, wasAuthenticated) => {
  if (!hasFeature('chat')) return
  if (isAuthenticated) chatStore.claimGuest()
  else if (wasAuthenticated) chatStore.reset()
}, { immediate: true })

// Watch for route changes to cart view and refresh cart data
watch(() => route.path, async (newPath, oldPath) => {
  if (newPath === '/cart' && oldPath !== '/cart') {
    console.log('Navigated to cart, refreshing cart data...')
    try {
      await cartStore.getCart()
    } catch (error) {
      console.warn('Failed to refresh cart on navigation:', error)
    }
  }
})

onMounted(() => {
  console.log('App mounted, stores should be initialized')
})
</script>

<template>
  <RouterView class="custom-cursor" />
  <ChatWidget v-if="hasFeature('chat')" />
  <CookieConsentComponent />
</template>

<style>
  /* Chrome, Safari, Edge, Opera */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
-webkit-appearance: none;
margin: 0;
}

/* Firefox */
input[type=number] {
-moz-appearance: textfield;
}
</style>